import { useEffect } from 'react';

export function useChunkErrorHandler() {
  useEffect(() => {
    const handler = (event) => {
      const message = event?.message || '';

      // Check if it's a chunk loading error
      if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
        console.warn('⚠️ Chunk load error detected, forcing reload...');
        // Force reload to get fresh assets
        window.location.reload(true);
      }
    };

    window.addEventListener('error', handler);

    return () => {
      window.removeEventListener('error', handler);
    };
  }, []);
}
